
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import * as Utils from '@Cyclope-Utils/index';
import {ExtractorVideoActionFail, ExtractorVideoActionInProgress, ExtractorVideoActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';



/**
 * @function ExtractorVideoActionCreator
 * @param { any} incidentParams
 * @return {Promise<any>}  Promise
 */
export function ExtractorVideoActionCreator(incidentParams: any): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ExtractorVideoActionInProgress());
        await Utils.fetchExtractVideo(incidentParams)
        .then((response: any)=> {
      if (response.ok) {
        /**
         * @constant
         * @name contentHeader
         * @type string
         */
        const contentHeader: string = response.headers.get('content-type');
        { /* Comparer les valeurs */
        }
        if (contentHeader && contentHeader !== null &&
            contentHeader.indexOf('video/avi') !== -1) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat en JSON  */
            }
            response.blob().then((data: any) => {
              const objectURL = URL.createObjectURL(data);
              dispatch(ExtractorVideoActionSuccess(data));
              window.location.assign(objectURL);
            });  // État du state : resultat final
          }
          if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.json().then(
                (text: any) => dispatch(ExtractorVideoActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
        if (contentHeader === null || contentHeader === undefined) {
          if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(ExtractorVideoActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
      } else {
        throw ({
          message: response.statusText,
          status: response.status,
          url: response.url,
          headers: response.headers
        });
      }}).catch( (error: any) => {
                dispatch(ExtractorVideoActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                Utils.fetchLogs(error.url,error.message,error.status,error.headers)
            })
  }
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/supervision/extractor/home/index.ts